module.exports = __webpack_public_path__ + "img/icon-05.83cd341c.png";